import React from 'react';
import AuthStore from 'auth-store';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import BillerSettlement from './BillerSettlement';
import OrgSettlement from './OrgSettlement';
import ViewBillerSettlement from '../components/ViewBillerSettlement';

function SettlementRoutes() {
  const match = useRouteMatch();
  const userRole = AuthStore.get('_role');

  return (
    <Switch>
      {userRole === 'biller' && (
        <Route exact path={match.path} component={BillerSettlement} />
      )}
      {userRole === 'organization' && (
        <Route exact path={match.path} component={OrgSettlement} />
      )}
      <Route
        path={`${match.path}/:merchant_id/view/:settlement_id`}
        component={ViewBillerSettlement}
      />
    </Switch>
  );
}

SettlementRoutes.propTypes = {};

export default SettlementRoutes;
